module.exports = __webpack_public_path__ + "img/ring_g_e_0_null.e023aa20.png";